import React, { FC, useEffect } from 'react';

import { TextField } from '@sitecore-jss/sitecore-jss-react';
import { signIn } from 'next-auth/react';

import RichText from '@components/RichText/RichText';
import { TrackedNotificationBox } from '@components/TrackedNotificationBox/TrackedNotificationBox';
import { NotificationField } from '@sitecore/types/AddressStep';
import { Button, Stack } from '@sparky';
import { StackProps } from '@sparky/types';

interface Props extends Pick<StackProps, 'alignY'> {
  type?: 'GENERIC' | 'AUTHENTIFICATION';
  textualData: {
    notification?: NotificationField;
    buttonLabel?: TextField;
  };
}

export const Error: FC<Props> = ({ textualData, alignY, type = 'GENERIC' }) => {
  useEffect(() => {
    if (type === 'AUTHENTIFICATION') signIn('okta');
  }, [type]);

  return (
    <>
      {textualData?.notification && (
        <TrackedNotificationBox
          label={textualData.notification.value?.title}
          title={textualData.notification.value?.title}
          isAlert
          text={<RichText html={textualData.notification.value?.content} />}
          variant={textualData.notification.value?.variant}
        />
      )}

      {textualData?.buttonLabel && type !== 'AUTHENTIFICATION' && (
        <Stack direction={{ initial: 'column', md: 'row' }} alignY={alignY}>
          <Button type="button" onClick={() => window.location.reload()}>
            {textualData.buttonLabel.value}
          </Button>
        </Stack>
      )}
    </>
  );
};
